import { render, staticRenderFns } from "./ProductItemCard.vue?vue&type=template&id=52070f28&"
import script from "./ProductItemCard.vue?vue&type=script&lang=js&"
export * from "./ProductItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports